import { Modal } from 'almanac-ui/Modal'
import Styles from './BrandWizardIntegrationSelection.module.scss'
import { Button } from 'blaze-ui/Button'
import { PrimaryButtons } from './PrimaryButtons'
import { Body } from './Body'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { useState } from 'react'
import { useModals } from 'almanac-ui/Modal'
import { BrandVisualKit } from 'types'
import { BrandStyle } from 'blaze-ui/icons/32'

interface Props {
  onConfirm: (kit: BrandVisualKit) => void
}

const BrandWizardIntegrationSelection = ({ onConfirm }: Props) => {
  const [selectedIntegration, setSelectedIntegration] = useState<ExternalIntegration>()
  const { closeModal } = useModals()

  return (
    <Modal.Root size="sm" aria-label="Create Brand Style" onPressOutside={closeModal}>
      <Modal.Header
        title={
          <div className={Styles.title}>
            <BrandStyle />
            Create Brand Style
          </div>
        }
      />

      <Modal.Content>
        <img
          className={Styles.hero}
          src="https://res.cloudinary.com/almanac/image/upload/v1732222694/blaze_assets/image_qcpdqt.jpg"
          alt=""
        />
        <Body selectedIntegration={selectedIntegration} onSelectIntegration={setSelectedIntegration} />
      </Modal.Content>

      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Button>
        </Modal.FooterContent>

        <Modal.FooterContent slot="right">
          <PrimaryButtons selectedIntegration={selectedIntegration} onConfirm={onConfirm} />
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { BrandWizardIntegrationSelection }
